import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4adce648"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "form-wrap" }
const _hoisted_4 = { class: "form-dynamic-row form-group-col-1" }
const _hoisted_5 = { class: "form-dynamic-row form-group-col-2" }
const _hoisted_6 = { class: "form-dynamic-row form-group-col-2" }
const _hoisted_7 = { class: "operations-wrap" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_select_option = _resolveComponent("select-option")!
  const _component_number_field = _resolveComponent("number-field")!
  const _component_time_picker = _resolveComponent("time-picker")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "modal_mask",
        onMousedown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeModal($event))),
        class: "modal-mask"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            id: "close-modal",
            to: { name: 'schedules' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'times'] })
            ]),
            _: 1
          }),
          _createElementVNode("h1", _hoisted_2, _toDisplayString(!_ctx.schedule_id ? "Novo " : "") + "Horário", 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Form, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_select_option, {
                    name: 'specialty',
                    label: 'Atuação',
                    readonly: true,
                    options: _ctx.select_options.specialties,
                    empty_message: 'Cadastre uma especialidade',
                    modelValue: _ctx.body.acting_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.body.acting_id) = $event)),
                    onUpdateValidation: _ctx.updateValidation
                  }, null, 8, ["options", "modelValue", "onUpdateValidation"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_select_option, {
                    name: 'week_day',
                    label: 'Dia da semana',
                    required: true,
                    options: [
                  { value: 0, label: 'Segunda-feira' },
                  { value: 1, label: 'Terça-feira' },
                  { value: 2, label: 'Quarta-feira' },
                  { value: 3, label: 'Quinta-feira' },
                  { value: 4, label: 'Sexta-feira' },
                ],
                    modelValue: _ctx.body.week_day,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.body.week_day) = $event)),
                    onUpdateValidation: _ctx.updateValidation
                  }, null, 8, ["modelValue", "onUpdateValidation"]),
                  _createVNode(_component_number_field, {
                    name: 'max_visits',
                    label: 'Número de atendimentos',
                    modelValue: _ctx.body.max_visits,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.body.max_visits) = $event)),
                    minlength: 0,
                    maxlength: 20,
                    validators: { required: {} },
                    onUpdateValidation: _ctx.updateValidation
                  }, null, 8, ["modelValue", "onUpdateValidation"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_time_picker, {
                    name: 'start_time',
                    label: 'Início atendimento',
                    modelValue: _ctx.body.start_time,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.body.start_time) = $event)),
                    custom_clock: _ctx.clocks.start,
                    disabled: 
                  _ctx.body.week_day === undefined || _ctx.clocks.start.length == 0
                ,
                    required: true,
                    onUpdateValidation: _ctx.updateValidation
                  }, null, 8, ["modelValue", "custom_clock", "disabled", "onUpdateValidation"]),
                  _createVNode(_component_time_picker, {
                    modelValue: _ctx.body.end_time,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.body.end_time) = $event)),
                    name: 'end_time',
                    label: 'Fim atendimento',
                    custom_clock: _ctx.clocks.end,
                    disabled: !_ctx.field_valid.start_time,
                    required: true,
                    onUpdateValidation: _ctx.updateValidation
                  }, null, 8, ["modelValue", "custom_clock", "disabled", "onUpdateValidation"])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: _normalizeClass({
              btn: true,
              'btn-update': !_ctx.isLoading && _ctx.isFormValid && !!_ctx.schedule_id,
              'btn-new': !_ctx.isLoading && _ctx.isFormValid && !!!_ctx.schedule_id,
            }),
              disabled: !_ctx.isFormValid || _ctx.isLoading,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, " Salvar ", 10, _hoisted_8)
          ])
        ])
      ], 544)
    ]),
    _: 1
  }))
}